import { render, staticRenderFns } from "./HomeCustomerDistribution.vue?vue&type=template&id=36f70838&scoped=true&"
import script from "./HomeCustomerDistribution.vue?vue&type=script&lang=js&"
export * from "./HomeCustomerDistribution.vue?vue&type=script&lang=js&"
import style0 from "./HomeCustomerDistribution.vue?vue&type=style&index=0&id=36f70838&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "36f70838",
  null
  
)

export default component.exports